import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
const T = (key, params) => app.translator.trans(`kapok-plus-verified-badge.forum.settings.${key}`, params);

/**
 * 用户设置页中的「学生认证」区块：状态展示 + 材料上传 + 提交记录。
 */
export default class VerificationSection extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.type = 'campus_card';
    this.file = null;
    this.loading = true;
    this.submitting = false;
    this.records = [];
    this.verified = false;
  }
  oncreate(vnode) {
    super.oncreate(vnode);
    this.load();
  }
  apiUrl() {
    return app.forum.attribute('apiUrl');
  }
  maxMb() {
    return Math.max(1, Math.round((app.forum.attribute('kapokVerifiedMaxFileSizeKb') || 10240) / 1024));
  }
  load() {
    this.loading = true;
    app.request({
      method: 'GET',
      url: `${this.apiUrl()}/kapok-verifications`,
      deserialize: JSON.parse
    }).then(response => {
      this.records = response && response.items || [];
      this.verified = !!(response && response.isScutVerified);
    }).catch(() => {}).then(() => {
      this.loading = false;
      m.redraw();
    });
  }
  latest() {
    return this.records[0] || null;
  }
  statusLabel(record) {
    if (!record) return T('status_none');
    const map = {
      pending: 'status_pending',
      approved: 'status_approved',
      rejected: 'status_rejected'
    };
    return T(map[record.status] || 'status_none');
  }
  typeLabel(type) {
    return T(type === 'admission_letter' ? 'type_admission_letter' : 'type_campus_card');
  }
  submit() {
    if (!this.file) {
      app.alerts.show({
        type: 'error'
      }, T('file_required'));
      return;
    }
    const body = new FormData();
    body.append('type', this.type);
    body.append('image', this.file);
    this.submitting = true;
    app.request({
      method: 'POST',
      url: `${this.apiUrl()}/kapok-verifications`,
      // FormData 不能被 JSON 序列化
      serialize: raw => raw,
      body
    }).then(() => {
      app.alerts.show({
        type: 'success'
      }, T('success'));
      this.file = null;
      const input = document.getElementById('kapok-verification-file');
      if (input) input.value = '';
      this.load();
    }).catch(() => {
      // 具体原因由 Flarum 默认错误处理弹出（JSON:API detail）
    }).then(() => {
      this.submitting = false;
      m.redraw();
    });
  }
  statusBlock() {
    const latest = this.latest();
    const status = this.verified ? 'approved' : latest ? latest.status : 'none';
    return m("div", {
      className: `kapokVerification-status kapokVerification-status--${status}`
    }, m("span", {
      className: "kapokVerification-statusLabel"
    }, this.statusLabel(this.verified ? {
      status: 'approved'
    } : latest)), latest && latest.status === 'rejected' && latest.rejectReason ? m("span", {
      className: "kapokVerification-rejectReason"
    }, T('reject_reason', {
      reason: latest.rejectReason
    })) : null);
  }
  uploadForm() {
    // 已认证或审核中时不再显示上传表单
    if (this.verified) return null;
    const latest = this.latest();
    if (latest && latest.status === 'pending') return null;
    return m("div", {
      className: "kapokVerification-form"
    }, m("div", {
      className: "Form-group"
    }, m("label", {
      className: "label"
    }, T('type_label')), m("div", null, m("label", {
      className: "checkbox"
    }, m("input", {
      type: "radio",
      name: "kapokVerificationType",
      value: "campus_card",
      checked: this.type === 'campus_card',
      onchange: () => {
        this.type = 'campus_card';
      }
    }), T('type_campus_card')), m("label", {
      className: "checkbox"
    }, m("input", {
      type: "radio",
      name: "kapokVerificationType",
      value: "admission_letter",
      checked: this.type === 'admission_letter',
      onchange: () => {
        this.type = 'admission_letter';
      }
    }), T('type_admission_letter')))), m("div", {
      className: "Form-group"
    }, m("label", {
      className: "label",
      for: "kapok-verification-file"
    }, T('file_label')), m("input", {
      id: "kapok-verification-file",
      className: "FormControl",
      type: "file",
      accept: "image/jpeg,image/png,image/webp",
      onchange: e => {
        this.file = e.target.files && e.target.files[0] ? e.target.files[0] : null;
      }
    }), m("p", {
      className: "helpText"
    }, T('file_hint', {
      max: this.maxMb()
    }))), m("div", {
      className: "Form-group"
    }, m(Button, {
      className: "Button Button--primary",
      loading: this.submitting,
      onclick: () => this.submit()
    }, latest && latest.status === 'rejected' ? T('resubmit') : T('submit'))));
  }
  history() {
    if (!this.records.length) return null;
    return m("div", {
      className: "kapokVerification-history"
    }, m("h4", null, T('history_title')), m("ul", null, this.records.map(record => m("li", {
      key: record.id
    }, m("span", {
      className: `kapokVerification-dot kapokVerification-dot--${record.status}`
    }), m("span", {
      className: "kapokVerification-historyType"
    }, this.typeLabel(record.type)), m("span", {
      className: "kapokVerification-historyStatus"
    }, this.statusLabel(record)), m("a", {
      className: "kapokVerification-historyLink",
      href: `${this.apiUrl()}/kapok-verifications/${record.id}/image`,
      target: "_blank",
      rel: "noopener noreferrer"
    }, T('view_image'))))));
  }
  view() {
    return m("div", {
      className: "kapokVerification"
    }, m("h3", {
      className: "kapokVerification-title"
    }, T('title')), m("p", {
      className: "helpText"
    }, T('description')), this.loading ? m(LoadingIndicator, null) : [this.statusBlock(), this.uploadForm(), this.history()]);
  }
}
flarum.reg.add('kapok-plus-verified-badge', 'forum/components/VerificationSection', VerificationSection);